<template>
  <!-- 全局toast -->
  <div class="k-toast k-body-md" v-if="visible">
    <span>{{ content }}</span>
    <div class="close-icon" @click="visible=false" v-if="showClose">
      <KkIcon name="ic_cross_line_semibold_lg" size="sm" />
    </div>
  </div>
</template>

<script>
import { KkIcon } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon
  },
  data() {
    return {
      content: '',
      visible: false,
      showClose: true
    }
  },
  methods: {
    showToast(options) {
      let duration = 4000
      if (typeof options === 'string') {
        this.content = options
      } else {
        this.content = options.content || ''
        this.showClose = options.showClose === false ? false : true
        duration = options.duration
        if (!options.duration && options.duration !== 0) {
          duration = 4000
        }
      }
      this.visible = true
      if (duration > 0) {
        setTimeout(() => {
          this.visible = false
        }, duration)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.k-toast {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%, 0%);
  min-width: 300px;
  max-width: 500px;
  left: 50%;
  top: calc(70px + 24px);
  padding: var(--kk-spacing-3) var(--kk-spacing-3) var(--kk-spacing-3) var(--kk-spacing-6);
  box-sizing: border-box;
  background: #404040;
  color: var(--kk-color-white);
  border-radius: var(--kk-radius-md);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--kk-spacing-2);
  .close-icon {
    cursor: pointer;
    padding: var(--kk-spacing-2);
    box-sizing: border-box;
  }
}
</style>
